module.exports = __webpack_public_path__ + "static/media/photo2.f7e3d355.jpeg";